import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { Translate } from "react-redux-i18n";

import Rating from "../../utils/components/Rating";

import { parseAddress } from "../../utils/Utils";

import "../../../styles/components/insights/insights/MostUsedCP.scss";
import marker from "../../../styles/images/markers/marker_public_grey.svg";
import evio_marker from "../../../styles/images/markers/marker_evio.svg";
import "../../../styles/utils/_loadingScreen.scss";

class MostUsedCP extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="mostUsedCP" className="highlight-container">
        {!this.props.loading ? (
          <>
            <div className="highlight-container-header">
              <img src={marker} alt="" />
              <Translate value="insights_mostUsedCP" />
            </div>
            <div className="highlight-container-body">
              <div className="cp-container">
                <div className="cp-icon">
                  {this.props.cp &&
                  !_.isEmpty(this.props.cp) &&
                  this.props.cp.imageContent &&
                  this.props.cp.imageContent !== "" ? (
                    <img src={this.props.cp.imageContent} alt="" />
                  ) : this.props.cp &&
                    this.props.cp.defaultImage &&
                    this.props.cp.defaultImage !== "" ? (
                    <img src={this.props.cp.defaultImage} alt="" />
                  ) : (
                    <img
                      src={
                        this.props.brand?.icons?.mapIcons?.[
                          `marker_${_.camelCase(this.props.brand?.brandName)}`
                        ] || evio_marker
                      }
                      alt=""
                      style={{ objectFit: "scale-down" }}
                    />
                  )}
                </div>
                {this.props.cp && !_.isEmpty(this.props.cp) && (
                  <div className="cp-info">
                    <Rating value={Math.round(this.props.cp.rating)} />
                    <p>{this.props.cp.name}</p>
                    <p>{parseAddress(this.props.cp.address)}</p>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="loading-container">
            <div className="loading-spinner">
              <div className="generic-loading">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(MostUsedCP);
